import KlarnaFooter from './KlarnaFooter';

export default KlarnaFooter;
